import { render, staticRenderFns } from "./AsignarPreguntas.vue?vue&type=template&id=4ba1b592"
import script from "./AsignarPreguntas.vue?vue&type=script&lang=js"
export * from "./AsignarPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports